import { useAppSelector } from 'hooks/redux'

const Loader = () => {
  const loader = useAppSelector(state => state.loader.row)
  return loader ? 'navLoader' : ''
}

export default Loader
